var _defs, _namedview2, _metadata;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    _dc: "http://purl.org/dc/elements/1.1/",
    _cc: "http://creativecommons.org/ns#",
    _rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    _svg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    _sodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    _inkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: "18.035334mm",
    height: "17.500378mm",
    viewBox: "0 0 18.035334 17.500378",
    id: "svg13826",
    _version: "0.91 r13725",
    _docname: "pod.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs13820"
  })), _namedview2 || (_namedview2 = /*#__PURE__*/React.createElement(_namedview, {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    _pageopacity: 0,
    _pageshadow: 2,
    _zoom: 8,
    _cx: 16.847496,
    _cy: 33.752239,
    "_document-units": "mm",
    "_current-layer": "layer1",
    showgrid: "false",
    "_window-width": 1440,
    "_window-height": 775,
    "_window-x": 0,
    "_window-y": 1,
    "_window-maximized": 1,
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata13823"
  }, /*#__PURE__*/React.createElement(_RDF, null, /*#__PURE__*/React.createElement(_Work, {
    _about: ""
  }, /*#__PURE__*/React.createElement(_format, null, "image/svg+xml"), /*#__PURE__*/React.createElement(_type, {
    _resource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement(_title, null))))), /*#__PURE__*/React.createElement("g", {
    _label: "Calque 1",
    _groupmode: "layer",
    id: "layer1",
    transform: "translate(-0.99262638,-1.174181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g70",
    transform: "matrix(1.0148887,0,0,1.0148887,16.902146,-2.698726)"
  }, /*#__PURE__*/React.createElement("path", {
    "_export-ydpi": 250.55,
    "_export-xdpi": 250.55,
    "_export-filename": "new.png",
    "_connector-curvature": 0,
    id: "path3055",
    d: "m -6.8492015,4.2724668 a 1.1191255,1.1099671 0 0 0 -0.4288818,0.1085303 l -5.8524037,2.7963394 a 1.1191255,1.1099671 0 0 0 -0.605524,0.7529759 l -1.443828,6.2812846 a 1.1191255,1.1099671 0 0 0 0.151943,0.851028 1.1191255,1.1099671 0 0 0 0.06362,0.08832 l 4.0508,5.036555 a 1.1191255,1.1099671 0 0 0 0.874979,0.417654 l 6.4961011,-0.0015 a 1.1191255,1.1099671 0 0 0 0.8749788,-0.416906 L 1.3818872,15.149453 A 1.1191255,1.1099671 0 0 0 1.5981986,14.210104 L 0.15212657,7.9288154 A 1.1191255,1.1099671 0 0 0 -0.45339794,7.1758396 L -6.3065496,4.3809971 A 1.1191255,1.1099671 0 0 0 -6.8492015,4.2724668 Z",
    style: {
      fill: "#326ce5",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3054-2-9",
    d: "M -6.8523435,3.8176372 A 1.1814304,1.171762 0 0 0 -7.3044284,3.932904 l -6.1787426,2.9512758 a 1.1814304,1.171762 0 0 0 -0.639206,0.794891 l -1.523915,6.6308282 a 1.1814304,1.171762 0 0 0 0.160175,0.89893 1.1814304,1.171762 0 0 0 0.06736,0.09281 l 4.276094,5.317236 a 1.1814304,1.171762 0 0 0 0.92363,0.440858 l 6.8576188,-0.0015 a 1.1814304,1.171762 0 0 0 0.9236308,-0.44011 l 4.2745966,-5.317985 a 1.1814304,1.171762 0 0 0 0.228288,-0.990993 L 0.53894439,7.6775738 A 1.1814304,1.171762 0 0 0 -0.10026101,6.8834313 L -6.2790037,3.9321555 A 1.1814304,1.171762 0 0 0 -6.8523435,3.8176372 Z m 0.00299,0.4550789 a 1.1191255,1.1099671 0 0 1 0.5426517,0.1085303 l 5.85315169,2.7948425 A 1.1191255,1.1099671 0 0 1 0.15197811,7.9290648 L 1.598051,14.21035 a 1.1191255,1.1099671 0 0 1 -0.2163123,0.939348 l -4.0493032,5.037304 a 1.1191255,1.1099671 0 0 1 -0.8749789,0.416906 l -6.4961006,0.0015 a 1.1191255,1.1099671 0 0 1 -0.874979,-0.417652 l -4.0508,-5.036554 a 1.1191255,1.1099671 0 0 1 -0.06362,-0.08832 1.1191255,1.1099671 0 0 1 -0.151942,-0.851028 l 1.443827,-6.2812853 a 1.1191255,1.1099671 0 0 1 0.605524,-0.7529758 l 5.8524036,-2.7963395 a 1.1191255,1.1099671 0 0 1 0.4288819,-0.1085303 z",
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      baselineShift: "baseline",
      textAnchor: "start",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      marker: "none",
      enableBackground: "accumulate"
    },
    "_connector-curvature": 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "text2066",
    y: 16.811775,
    x: 10.017183,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "10.58333302px",
      lineHeight: "6.61458349px",
      fontFamily: "Sans",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.26458332px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "2.82222223px",
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial, Normal'",
      textAlign: "center",
      writingMode: "lr-tb",
      textAnchor: "middle",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: "0.26458332px"
    },
    y: 16.811775,
    x: 10.017183,
    id: "tspan2064",
    _role: "line"
  }, "pod")), /*#__PURE__*/React.createElement("g", {
    id: "g3341",
    transform: "translate(0.12766661,0)"
  }, /*#__PURE__*/React.createElement("path", {
    "_export-ydpi": 376.57999,
    "_export-xdpi": 376.57999,
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.26458332,
      strokeLinecap: "square",
      strokeMiterlimit: 10
    },
    "_connector-curvature": 0,
    d: "M 6.2617914,7.036086 9.8826317,5.986087 13.503462,7.036086 9.8826317,8.086087 Z",
    id: "path910"
  }), /*#__PURE__*/React.createElement("path", {
    "_export-ydpi": 376.57999,
    "_export-xdpi": 376.57999,
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.26458332,
      strokeLinecap: "square",
      strokeMiterlimit: 10
    },
    "_connector-curvature": 0,
    d: "m 6.2617914,7.43817 0,3.852778 3.3736103,1.868749 0.0167,-4.713193 z",
    id: "path912"
  }), /*#__PURE__*/React.createElement("path", {
    "_export-ydpi": 376.57999,
    "_export-xdpi": 376.57999,
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.26458332,
      strokeLinecap: "square",
      strokeMiterlimit: 10
    },
    "_connector-curvature": 0,
    d: "m 13.503462,7.43817 0,3.852778 -3.37361,1.868749 -0.0167,-4.713193 z",
    id: "path914"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPod);
export default __webpack_public_path__ + "static/media/pod.687fc9786767629dff54f41647ca4f8c.svg";
export { ForwardRef as ReactComponent };